import './Report.css';

import { Button, Modal } from 'react-bootstrap';
import React, { useContext, useEffect, useState } from "react";

import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";

export default function ChangePassword({ show, handleClose }) {
    const [showIng, setShowIng] = useState(false);
    const [form, setForm] = useState({});
    const [isLoading, setIsLoading] = useState(false);


    const handleCloseIng = () => {
        setShowIng(false);
        handleClose(null);
    }

    useEffect(() => {
        setShowIng(show);
    }, [show]);

    const handlePost = async (e) => {
        e.preventDefault();

        if (form.oldPassword.length == 0) {
            toast.error('کلمه عبور گذشته وارد نشده است', { theme: "colored" });
            return;
        } else if (form.newPassword.length == 0) {
            toast.error('کلمه عبور جدید  وارد نشده است', { theme: "colored" });
            return;
        } else if (form.confirmPassword.length == 0) {
            toast.error('تکرار کلمه عبور وارد نشده است', { theme: "colored" });
            return;
        } else if (form.confirmPassword != form.newPassword) {
            toast.error('کلمه عبور جدید و تکرار کلمه عبور یکسان نمی باشد', { theme: "colored" });
            return;
        }

        setIsLoading(true);
        const response = await noronServices.ChangePassword({
            oldPassword: form.oldPassword,
            newPassword: form.newPassword
        })
            .then(({ data }) => {
                setIsLoading(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return;
                }
                http.logout();
                http.goLogin();
                handleClose(form);
            })
            .catch(err => {
                setIsLoading(false);
            });
    }



    return (
        <>

            <Modal show={showIng} onHide={handleCloseIng} id="modalPatient" centered>
                <Modal.Header closeButton>
                    <Modal.Title className="colorRed">تغییر کلمه عبور
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container">
                        <div className="form-floating mb-3">
                            <input asp-for="oldPassword"
                                type="password"
                                name="oldPassword"
                                value={form.oldPassword}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control" placeholder="کلمه عبور فعلی" autoComplete="off" />
                            <label asp-for="oldPassword">کلمه عبور فعلی</label>
                            <span asp-validation-for="oldPassword" className="text-danger"></span>
                        </div>
                        <div className="form-floating mb-3">
                            <input asp-for="newPassword"
                                type="password"
                                name="newPassword"
                                value={form.newPassword}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control" placeholder="کلمه عبور جدید" autoComplete="off" />
                            <label asp-for="newPassword">کلمه عبور جدید</label>
                            <span asp-validation-for="newPassword" className="text-danger"></span>
                        </div>
                        <div className="form-floating mb-3">
                            <input asp-for="confirmPassword"
                                type="password"
                                name="confirmPassword"
                                value={form.confirmPassword}
                                onChange={e => http.handleChange(e, form, setForm)}
                                className="form-control" placeholder="تکرار کلمه عبور جدید" autoComplete="off" />
                            <label asp-for="confirmPassword">تکرار کلمه عبور جدید</label>
                            <span asp-validation-for="confirmPassword" className="text-danger"></span>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" className="col btn btn-success btn-block myCustomButton"
                        onClick={handlePost}
                        disabled={isLoading}>
                        {isLoading &&
                            <div className="spinner-border spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>}
                        <span>&nbsp;&nbsp;&nbsp;تایید </span>
                    </Button>
                    <Button variant="danger" className="col btn btn-danger myCustomButton" data-bs-dismiss="modal"
                        onClick={handleCloseIng}>
                        <span>&nbsp;&nbsp;&nbsp;انصراف</span>
                    </Button>
                </Modal.Footer>
            </Modal>
        </>

    );

}
